/**
 * DeviceId Plugin - Lazy Loading Version
 *
 * Returns the real Android Settings.Secure.ANDROID_ID,
 * the same value as: adb shell settings get secure android_id
 *
 * Uses Capacitor.isPluginAvailable() to check if the native plugin exists
 * before registering, preventing "not implemented on android" errors.
 */

let _pluginInstance = null;
let _initializationPromise = null;

const getPlugin = async () => {
  if (_pluginInstance !== null) {
    return _pluginInstance;
  }

  if (_initializationPromise) {
    return _initializationPromise;
  }

  _initializationPromise = (async () => {
    try {
      const { Capacitor, registerPlugin } = await import('@capacitor/core');

      if (Capacitor.isPluginAvailable('DeviceId')) {
        _pluginInstance = registerPlugin('DeviceId');
        console.log('[DeviceId] Native plugin available');
      } else {
        console.log('[DeviceId] Native plugin not available');
        _pluginInstance = false; // sentinel: not available
      }
    } catch (err) {
      console.warn('[DeviceId] Init failed:', err.message);
      _pluginInstance = false;
    }

    return _pluginInstance;
  })();

  return _initializationPromise;
};

const DeviceId = {
  async getAndroidId() {
    try {
      const plugin = await getPlugin();
      if (!plugin) {
        return { androidId: null };
      }
      return await plugin.getAndroidId();
    } catch (err) {
      console.error('[DeviceId] getAndroidId failed:', err);
      return { androidId: null };
    }
  },
};

export default DeviceId;
